import "./App.css";
import { useLayoutEffect } from "react";

// import { useScrollAnimations } from "./hooks/useScrollAnimations";
import ScrollProgress from "./hooks/ScrollProgress";
import StarsBackground from "./components/stars/stars";

import About from "./pages/about/about";
import StickyHeader from "./pages/header/header";
import Intro from "./pages/intro/intro";
import Skills from "./pages/skills/skills";
import Projects from "./pages/projects/projects";
import Footer from "./pages/footer/footer";
// import Hero from "./pages/hero/hero";
import Contact from "./pages/contact/contact";
import FloatingNav from "./components/floating-nav/floating-nav";
// import Process from "./pages/process/process";

function App() {
  // Inicializa o AOS antes dos hooks de animação
  useLayoutEffect(() => {
    if (typeof window !== "undefined" && window.AOS) {
      window.AOS.init({
        once: true,
        duration: 700,
        easing: "ease-out-quart",
        offset: 80,
      });
      window.AOS.refresh();
    }
  }, []);

  return (
    <div className="app theme-space">
      <ScrollProgress />
      {/* <Preloader /> */}
      <StarsBackground fullScreen stars={500} vel={2} radius={1.5} />

      <div className="app-shell">
        <StickyHeader />
        <main>
          {/* <Hero /> */}
          {/* Este é o "post-hero" de fato; o GSAP usa o ref do Hero para controlar */}
          <div id="post-hero">
            {/* <section id="section-scroll-id" className="section-scroll"></section> */}
            <Intro />
            <About />
            {/* <Process /> */}
            <Skills />
            <Projects />
            <Contact />
            <Footer />
          </div>
        </main>
      </div>
      <FloatingNav />
    </div>
  );
}

export default App;
